"use client";

import React from "react";
import CodPayment from "../../../components/CodPayment";

// Thin view wrapper that delegates to the shared CodPayment component.
export default function CodPaymentView(props) {
  return <CodPayment {...props} />;
}
